export enum CacheType {
    StandartTime = 0,
    LoadBeforeDate = 1,
    StandartTimeForContent = 2
}